import { apiService } from './api';
import { User } from '../types/auth';

export interface UpdateUserPayload {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
}

class UserService {
  async get(id: string): Promise<User> {
    const res = await apiService.get<{ success: boolean; data: User }>(`/users/${id}`);
    return res.data;
  }

  async update(id: string, data: UpdateUserPayload): Promise<User> {
    const res = await apiService.put<{ success: boolean; message: string; data: User }>(`/users/${id}`, data);
    return res.data;
  }
}

export const userService = new UserService();

